import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface SessionState {
  // identity
  userId: number;
  username: string;
  emis_username: string;
  name: string;
  teacher_name: string;
  Socialname: string;
  designation: string;
  phnumber: string;
  email: string;

  // school
  schoolName: string;
  schoolId: number;
  schoolKeyId: string;
  schoolTypeId: number;
  schlId: string;
  highClass: number;
  lowClass: number;

  // teacher
  teacherId: number;
  teacherType: string;
  type_teacher: string;
  subjects: string;
  subject_id: string;

  // user type / role
  usertype: string;
  usertypeid: string;
  emisUsertype1: string;
  roleId: number;
  offKeyId: string;

  // category
  cate_id: string;
  catty_id: string;
  cateType: string;
  category_type: string;
  manage_id: string;

  // location
  districtId: string;
  districtName: string;
  blockId: string;
  blockName: string;
  edu_dist_name: string;
  edn_dist_name: string;
  edu_district_id: string;

  // module permissions
  mod2: string;

  // switch login
  switch_login: string;
  switch_designation: string;

  // token / meta
  authToken: string;
  iat: number;
  tokenExpiry: number;

  loaded: boolean;
  user_role_level: string;
}

const initialState: SessionState = {
  userId: 0,
  username: '',
  emis_username: '',
  name: '',
  teacher_name: '',
  Socialname: '',
  designation: '',
  phnumber: '',
  email: '',
  schoolName: '',
  schoolId: 0,
  schoolKeyId: '',
  schoolTypeId: 0,
  schlId: '',
  highClass: 0,
  lowClass: 0,
  teacherId: 0,
  teacherType: '',
  type_teacher: '',
  subjects: '',
  subject_id: '',
  usertype: '',
  usertypeid: '',
  emisUsertype1: '',
  roleId: 0,
  offKeyId: '',
  cate_id: '',
  catty_id: '',
  cateType: '',
  category_type: '',
  manage_id: '',
  districtId: '',
  districtName: '',
  blockId: '',
  blockName: '',
  edu_dist_name: '',
  edn_dist_name: '',
  edu_district_id: '',
  mod2: '',
  switch_login: '',
  switch_designation: '',
  authToken: '',
  iat: 0,
  tokenExpiry: 0,
  loaded: false,
  user_role_level: '',
};

const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    loadSession(_state, action: PayloadAction<Omit<SessionState, 'loaded'>>) {
      return { ...action.payload, loaded: true };
    },
    clearSession() {
      return initialState;
    },
  },
});

export const { loadSession, clearSession } = sessionSlice.actions;
export default sessionSlice.reducer;
